import { Component, ElementRef, Input, OnDestroy, OnInit, SimpleChange, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../../app/common/constants/global.constant';
import { CommonService } from '../../../../common/services/common.service';
import { LivePreview } from './../../../interfaces/live-preview.i';

@Component({
  selector: 'iposcen-live-preview',
  templateUrl: './live-preview.component.html',
  styleUrls: ['./live-preview.component.scss'],
})
export class LivePreviewComponent implements OnInit, OnDestroy {
  previewData: LivePreview;
  isListPreview: boolean;
  headingLabel: string;
  bodyLabel: string;
  FILE_TYPE_IMAGE: string = GlobalConstants.FILE_TYPE_IMAGE;
  FILE_TYPE_VIDEO: string = GlobalConstants.FILE_TYPE_VIDEO;
  @ViewChild('preview1') bodyPreview1: ElementRef;
  @ViewChild('preview2') bodyPreview2: ElementRef;
  @ViewChild('preview3') bodyPreview3: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private cmnSer: CommonService) { }
  @Input() data;
  @Input() previewType;
  @Input() sidenav;
  @Input() customClass = false;
  activeCustomClass = false;
  @Input() isIdleExperienceEnable: string;
  @Input() miniPreview;
  smallText = false;
  largeText = false;
  MediumText = false;
  idleExpFullscreenEnabled = false;
  fullScreenCheckbox = true;
  tabArr: any[];
  fullScreen: boolean = false;
  videoFullScreen: boolean = false;
  setImageBackground: boolean = false;
  globConst = GlobalConstants;
  normalScreen: boolean = false;
  isIdleExp: string;
  previewTypes: string;
  isMiniPreview: boolean;
  isIdleExperiencePreview: boolean;

  ngOnInit(): void {
    this.headingLabel = $localize`:@@page.heading-label:HEADING`;
    this.bodyLabel = $localize`:@@page.body-label.name:Body`;
    this.isListPreview = false;
    this.previewType = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
    this.tabArr = [GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS, GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE];
    this.cmnSer.pageObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.previewData = data;
        this.getPreviewData();
        if (this.previewData.layout === 1) {
          setTimeout(_ => {
            this.bodyPreview1.nativeElement.innerHTML = data.body ? data.body : this.bodyLabel;
          }, 0)
        } else if (this.previewData.layout === 2) {
          setTimeout(_ => {
            this.bodyPreview2.nativeElement.innerHTML = data.body ? data.body : this.bodyLabel;
          }, 0)
        } else {
          setTimeout(_ => {
            this.bodyPreview3.nativeElement.innerHTML = data.body ? data.body : this.bodyLabel;
          }, 0)
        }
      });
    // passing default values
    this.previewData = {
      bgcolor: '#0068B5',
      heading: this.headingLabel,
      hcolor: '#ffffff',
      body: this.bodyLabel,
      size: 'Medium',
      media: {
        name: '',
        url: '',
        format: '',
      },
      layout: 1,
      bcolor: '#ffffff',
      previewType: GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS,
      idleExpFullscreenEnabled: false,
      fullScreenCheckbox: this.previewData?.fullScreenCheckbox
    };
    if (this.data) {
      this.isListPreview = true;
      this.data.heading = this.data.heading || ' ';
      this.data.body = this.data.body || ' ';
      this.previewData = JSON.parse(JSON.stringify(this.data));
    }
    if (this.customClass) {
      let lenghtOfBody = this.previewData.body.replace(/<[^>]+>/g, '').length
      this.activeCustomClass = lenghtOfBody >= 50;
      this.smallText = lenghtOfBody < 50;
      this.largeText = lenghtOfBody >= 150;
      this.MediumText = lenghtOfBody >= 50;

    }

    this.previewTypes = this.isIdleExperienceEnable;
    if (this.miniPreview) {
      this.isMiniPreview = true;
    } else {
      this.isMiniPreview = false;
    }
  }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if (changes.isIdleExperienceEnable) {
      this.isIdleExp = changes.isIdleExperienceEnable.currentValue;
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getPreviewData() {
    if (this.previewData?.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE) {
      this.isIdleExperiencePreview=true;
      this.getIDLEPreviewData();
    } else {
      this.isIdleExperiencePreview=false;
      this.getIPOSPreviewData();
    }
  }

  getIDLEPreviewData() {
    this.fullScreen = this.previewData?.idleExpFullscreenEnabled && this.isIdleExperiencePreview;
    this.normalScreen = this.isIdleExperiencePreview && !this.previewData?.idleExpFullscreenEnabled;
    this.videoFullScreen = this.previewData?.idleExpFullscreenEnabled && this.previewData.media.url != '' && this.previewData.media.format.includes(this.FILE_TYPE_VIDEO) && this.isIdleExperiencePreview;
    this.setImageBackground = this.previewData.idleExpFullscreenEnabled && this.previewData.media.url != '' && !(this.previewData.media.format.includes(this.FILE_TYPE_VIDEO)) && this.isIdleExperiencePreview;
  }

  getIPOSPreviewData() {
    this.fullScreen = this.previewData?.fullScreenCheckbox && !this.isIdleExperiencePreview && this.previewData.media.url != '';
    this.normalScreen = false;
    this.videoFullScreen = this.previewData?.fullScreenCheckbox && this.previewData.media.url != '' && this.previewData.media.format.includes(this.FILE_TYPE_VIDEO) && !this.isIdleExperiencePreview;
    this.setImageBackground = this.previewData.fullScreenCheckbox && this.previewData.media.url != '' && !(this.previewData.media.format.includes(this.FILE_TYPE_VIDEO)) && !this.isIdleExperiencePreview;
  }

  fontSize(size) {
    if (size === GlobalConstants.SMALL) {
      return GlobalConstants.FONTSIZE_12PX;
    }
    if (size === GlobalConstants.MEDIUM) {
      return GlobalConstants.FONTSIZE_14PX;
    }
    if (size === GlobalConstants.LARGE) {
      return GlobalConstants.FONTSIZE_16PX;
    }
  }

  setActiveTab(type: string) {
    this.cmnSer.emitPreviewType(type);
  }
}
